import React, { useState } from "react";
import axios from "axios";
import ViewPromotionalImg from "./ViewPromotionalImg";
import apiConfig from "../../../apiConfig";
import "./AddPromotionalImg.css";

const AddPromotionalImg = () => {
  const [loading, setLoading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedFileNames, setSelectedFileNames] = useState([]);
  const [context, setContext] = useState(""); 
  const [order, setOrder] = useState(0); 
  const [uploadResponse, setUploadResponse] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
    const fileNames = files.map((file) => file.name);
    setSelectedFileNames(fileNames);
  };

  const handleFileUpload = async () => {
    if (selectedFiles.length === 0) {
      alert("Please select one or more files.");
      return;
    }

    setLoading(true);

    try {
      const formData = new FormData();

      selectedFiles.forEach((file) => {
        formData.append("images", file);
      });
      formData.append("context", context);
      formData.append("order", order);

      const response = await axios.post(
        `${apiConfig.baseUrl}${apiConfig.UploadPromotionalOfferImg}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      setUploadResponse(response.data);
      alert("Images uploaded successfully");
      setError(null);
    } catch (error) {
      console.error("Error uploading images:", error);
      if (error.response && error.response.data) {
        setError(error.response.data.message);
      } else {
        setError("Error uploading images. Please try again.");
      }
    } finally {
      setLoading(false);
      setSelectedFiles([]);
      setSelectedFileNames([]);
    }
  };

  return (
    <div className="container">
      <h2>Add Promotional Images</h2>
      <div className="containertwo">
        <input
          type="file"
          id="fileInput"
          style={{ display: "none" }}
          onChange={handleFileChange}
          multiple
        /> Select Image
        <button
          className="label"
          onClick={() => document.getElementById("fileInput").click()}
        >
          Choose Files
        </button>
      
        {/* Display selected file names */}
        <div className="selected-files">
          {selectedFileNames.map((fileName, index) => (
            <p key={index}>{fileName}</p>
          ))}
        </div>

        {loading && <p className="loading-message">Loading...</p>}
        {error && <p className="error-message">{error}</p>}
      </div>

      {/* Input for context */}
      <div className="context-input-container">
        <label>Context:</label>
        <input
          type="text"
          value={context}
          onChange={(e) => setContext(e.target.value)}
          placeholder="Enter Screen"
          className="context-input"
        />
      </div>

      {/* Input for order */}
      <div className="order-input-container">
        <label>Order:</label>
        <input
          type="number"
          value={order}
          onChange={(e) => setOrder(e.target.value)}
          placeholder="Enter Order"
          className="order-input"
        />
      </div>

      <button className="button" onClick={handleFileUpload}>
        Upload Images
      </button>
    </div>
  );
};

export default AddPromotionalImg;
